module.exports = __webpack_public_path__ + "img/hezuo.73850e8c.gif";